import React, { useEffect, useState } from "react";
import WebUtils from "../../../utils/WebUtils";
import Utils from "../../../utils/Utils";
import { Card, Skeleton } from "antd";
import MockGuideCardPage from "./MockGuideCardPage";
import MockGuidePageNoData from "./MockGuidePageNoData";
import { getAllDronaConfig } from "../../../api/org-admin/index";

const userDetail = Utils.getUserDetail();
const pageSize = 6;

function MockGuideListPage({
  guideData,
  setGuideData,
  jobGuideFilters,
  mockGuideStatus,
  searchButtonText,
  setNotFoundFlag,
  notFoundFlag,
  moduleInfo,
}) {
  const [loading, setLoading] = useState(false);
  const [currPage, setCurrPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);

  const getJobGuides = (pageNo, pageSize, searchInput) => {
    const url = `${getAllDronaConfig}?organizationId=${userDetail?.organizationId}&pageNumber=${pageNo}&pageSize=${pageSize}&sortBy=${jobGuideFilters}&configState=${mockGuideStatus}&searchInput=${searchInput}`;

    

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          //   console.log(result.data);
          let count = result.data.data.totalCount;
          if (count === 0 && mockGuideStatus === "ALL") {
            setNotFoundFlag(true);
          } else {
            setNotFoundFlag(false);
          }
          setGuideData(result.data.data.iDronaConfigList);

          setPageCount(count);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "not_found"
        ) {
          setNotFoundFlag(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    setCurrPage(0);
    getJobGuides(0, pageSize, searchButtonText);
  }, [jobGuideFilters, mockGuideStatus, searchButtonText]);

  const onPageChange = (num) => {
    setCurrPage(num - 1);
    getJobGuides(num - 1, pageSize, searchButtonText);
  };
  return (
    <div>
      {loading ? (
        <div className="mt-4 flex flex-col items-center">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[1.1rem] gap-x-[1.3rem] w-full">
            <Card className="w-full ">
              <Skeleton active paragraph />
            </Card>
            <Card className="w-full ">
              <Skeleton active paragraph />
            </Card>
            <Card className="w-full ">
              <Skeleton active paragraph />
            </Card>
            <Card className="w-full ">
              <Skeleton active paragraph />
            </Card>
            <Card className="w-full ">
              <Skeleton active paragraph />
            </Card>
            <Card className="w-full ">
              <Skeleton active paragraph />
            </Card>
          </div>
        </div>
      ) : notFoundFlag || (guideData && guideData?.length > 0) ? (
        <MockGuideCardPage
          notFoundFlag={notFoundFlag}
          guideData={guideData}
          pageNumber={currPage}
          pageSize={pageSize}
          onPageChange={onPageChange}
          pageCount={pageCount}
        />
      ) : (
        !notFoundFlag &&
        (!guideData || guideData.length === 0) && (
          <MockGuidePageNoData
            // setSelectedTab={setSelectedTab}
            moduleInfo={moduleInfo}
          />
        )
      )}
    </div>
  );
}

export default MockGuideListPage;
